<template>
    <svg
        fill="none"
        height="19"
        viewBox="0 0 19 19"
        width="19"
        xmlns="http://www.w3.org/2000/svg">
        <rect
            fill="currentColor"
            height="19"
            rx="2.1"
            width="19" />
        <path
            d="M14.7444 5.79787C14.4041 5.45708 13.8514 5.45729 13.5106 5.79787L7.95766 11.351L5.48961 8.88301C5.14881 8.54222 4.59639 8.54222 4.2556 8.88301C3.9148 9.22381 3.9148 9.77623 4.2556 10.117L7.34052 13.202C7.51081 13.3722 7.7341 13.4576 7.95742 13.4576C8.18073 13.4576 8.40424 13.3725 8.57453 13.202L14.7444 7.03187C15.0852 6.69131 15.0852 6.13865 14.7444 5.79787Z"
            fill="white" />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
